module.exports = __webpack_public_path__ + "static/media/3pic.f6e9a199.jpg";